import * as THREE from 'three';
import gsap from 'gsap';
import { MojiPointsUtil } from '../utils/MojiPointsUtil';
import { MojisLine } from '../MojisLine';
import { LogoMarkStrokes } from './LogoMarkStrokes';
import { Moji } from '../Moji';
import { Params } from '../../data/Params';
import { MojiDot } from '../MojiDot';
import { LogoMarkMeshLine } from './LogoMarkMeshLine';
import { DataManager } from '../../data/DataManager';
import { LogoMarkMeshQbg } from './LogoMarkMeshQbg';


export class LogoMarkMesh extends THREE.Object3D{

    logo1:Moji;
    logo2:Moji;
    line:LogoMarkMeshLine;
    index:number=0;
    enabledDots:MojiDot[] = [];
    disabledDots:MojiDot[] = [];
    allDots:MojiDot[] = [];
    logoMarkBg      :LogoMarkMeshQbg;
    //logoMarkBgMat   :MeshBasicMaterial;
    count: number = 0;

    init(){

        let scale = 0.5;
        //ロゴのドットです
        this.logo1 = new Moji(Params.MOJI_LOGO1,0.026*scale,0.338*scale,0,8);
        this.logo2 = new Moji(Params.MOJI_LOGO2,-0.026*scale,-0.338*scale,0,8);
        this.logo1.scale.set(scale,scale,scale);
        this.logo2.scale.set(scale,scale,scale);
        this.logo1.position.x+=10;
        this.logo2.position.x+=10;
        
        this.logoMarkBg = new LogoMarkMeshQbg(
            DataManager.getInstance().logo2
        );
        this.logoMarkBg.scale.set(11,11,11)
        this.logoMarkBg.position.x = -23.5+10;
        this.logoMarkBg.position.y = -14.4;        
        this.logoMarkBg.position.z = -50;
        this.logoMarkBg.visible=false;
        this.add(this.logoMarkBg);

        //文字群です
        this.line = new LogoMarkMeshLine();
        this.line.init(0,0,7);
        this.line.scale.set(scale,scale,scale);
        this.line.position.x+=5;
        this.line.position.y=-300;

        this.position.y=100;

        this.add(this.logo1);
        this.add(this.logo2);
        this.add(this.line);

        //これ


        this.updateAllDots();
        for(let i=0;i<this.allDots.length;i++){
            this.allDots[i].enabled=false;
        }

        this.scale.set(1,1,1);

    }

    resetPoint(){

        this.index=0;

    }

    updateAllDots():MojiDot[]{
        this.allDots = [];
        this.allDots = this.allDots.concat(this.logo1.dots);
        this.allDots = this.allDots.concat(this.logo2.dots);
        this.allDots = this.allDots.concat(this.line.getAllDots());
        return this.allDots;
    }

    updateEnableDots(){
        this.enabledDots = this.line.getEnabledDots();
        this.enabledDots=this.enabledDots.concat(this.logo1.enabledDots);
        this.enabledDots=this.enabledDots.concat(this.logo2.enabledDots);
    }

    hideDots(){

        this.updateEnableDots();
        for(let i=0;i<this.enabledDots.length;i++){
            this.enabledDots[i].enabled=false;
        }

    }

    getNextPoint():MojiDot{
        
        if(this.allDots.length==0)return null;

        let dot = this.allDots[this.index%this.allDots.length];
        //console.log(this.index + "/" + this.allDots.length);
        this.index++;
        return dot;

    }

    showBg(){
        this.logoMarkBg.show();//ロゴマーク
        this.line.showBg();//ロゴタイプ
    }

    hideBg(){
        this.logoMarkBg.hide();
        this.line.hideBg();
    }

    blinkBg(){
        this.line.blinkBg(1);
    }

    public boost(){
        this.line.boost();
        this.logo1.addVelocity();
        this.logo2.addVelocity();
    }

    public showAllDots(){
        this.logo1?.SetAllEnabled(true);
        this.logo2?.SetAllEnabled(true);
        this.line?.showAllDots();
    }

    public hideAllDots(){
        this.logo1?.SetAllEnabled(false);
        this.logo2?.SetAllEnabled(false);
        this.line?.hideAllDots();
    }


    update(){
        
        this.line?.update();
        this.logo1?.update();
        this.logo2?.update();

        this.logoMarkBg?.update();

    }

}